import { createApi } from '@reduxjs/toolkit/query/react';
import { pensionBaseQuery } from '../../lib/axiosBaseQuery';

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: pensionBaseQuery,
  tagTypes: ['Notifications'],
  endpoints: (builder) => ({
    getNotifications: builder.query<any, void>({
      query: () => ({
        url: `api/v1/pension/notifications`,
        method: 'GET',
      }),
      transformResponse: (response: any) => {
        const raw = Array.isArray(response) ? response : response?.data ?? response?.notifications ?? [];
        const sorted = [...raw].sort((a: any, b: any) => new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime());
        return sorted;
      },
      providesTags: ['Notifications'],
    }),
    markNotificationAsRead: builder.mutation<any, string>({
      query: (id) => ({
        url: `api/v1/pension/notifications/${id}/read`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Notifications'],
    }),
    deleteNotification: builder.mutation<any, string>({
      query: (id) => ({
        url: `api/v1/pension/notifications/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notifications'],
    }),
    getFileUploadNotificationsBlob: builder.mutation<Blob, string>({
      query: (referenceId) => ({
        url: `api/v1/pension/notifications/upload/${referenceId}/file`,
        method: 'GET',
        responseType: 'blob',
      }),
    }),
    getFileUploadNotifications: builder.query<any, string>({
      query: (referenceId) => ({
        url: `api/v1/pension/notifications/upload/${referenceId}/file`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkNotificationAsReadMutation,
  useDeleteNotificationMutation,
  useGetFileUploadNotificationsBlobMutation,
  useGetFileUploadNotificationsQuery,
} = notificationsApi;
